import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IDropdownObject} from '../interfaces/dropdown-object.interface';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CompanyManagementService {
  private _companyUnits!: IDropdownObject[];
  private readonly apiUrl = `${environment.API}api/v1`;
  private readonly NON_DELIVERY_LABEL = 'Non-delivery';
  constructor(private http: HttpClient) {}

  get companyUnits(): IDropdownObject[] {
    return this._companyUnits;
  }

  set companyUnits(value: IDropdownObject[]) {
    this._companyUnits = value;
  }

  get deliveryUnits(): IDropdownObject[] {
    return this._companyUnits.filter(
      unit => unit.name !== this.NON_DELIVERY_LABEL
    );
  }

  get deliveryUnitIds(): number[] {
    return this.deliveryUnits.map(unit => unit.id as number);
  }

  getCompanyUnits(): Observable<IDropdownObject[]> {
    return this.http.get<IDropdownObject[]>(`${this.apiUrl}/DropDown/units`);
  }
}
